import Meta from '@/components/common/Meta'

import OfficeDocumentStorageSolutionsPage from '@/v2/components/pages/landing-pages/office-document-storage-solutions-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/office-document-storage-solutions-page'

interface OfficeDocumentStorageSolutionsPageProps {}

const Page: React.FC<OfficeDocumentStorageSolutionsPageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.office_document_storage_solutions.title ??
          LANDING_PAGES_META_CONTENTS.default?.title ??
          ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.office_document_storage_solutions?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.office_document_storage_solutions?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <OfficeDocumentStorageSolutionsPage />
    </>
  )
}

export default Page
